// Casas de Noxara (decisão do Arthur, 14/10): leilão de 7 dias com gold, aluguel semanal pago do banco, uma casa por conta,
// convidados, decoração com os itens do jogo e boneco de treino da casa (+10% no treino com exercise weapon).
// Guildhalls só para líderes de guild (os membros entram). Números da tabela propostos por mim e aprovados.

export type HouseSize = 'small' | 'medium' | 'large' | 'guild';
export interface HouseDef { id: number; name: string; size: HouseSize; minBid: number; rent: number }
export const HOUSE_SIZES: Record<HouseSize, { label: string; count: number; minBid: number; rent: number; decor: number }> = {
  small: { label: 'Pequena', count: 40, minBid: 500_000, rent: 50_000, decor: 30 },
  medium: { label: 'Média', count: 25, minBid: 2_000_000, rent: 150_000, decor: 60 },
  large: { label: 'Grande', count: 10, minBid: 8_000_000, rent: 400_000, decor: 100 },
  guild: { label: 'Guildhall', count: 5, minBid: 20_000_000, rent: 1_000_000, decor: 150 },
};
export const HOUSE_AUCTION_MS = 7 * 86400_000;
export const HOUSE_RENT_MS = 7 * 86400_000;
/** lance novo: pelo menos 5% acima do atual */
export const HOUSE_BID_STEP = 1.05;
/** treino com exercise weapon no boneco da própria casa rende 10% a mais (house dummy do Global) */
export const HOUSE_DUMMY_BONUS = 1.1;

const STREETS = ['Rua das Flores', 'Rua do Templo', 'Rua dos Mercadores', 'Avenida Noxara', 'Rua da Fonte', 'Travessa do Porto', 'Rua dos Ferreiros', 'Alameda das Torres'];
const GUILDHALLS = ['Fortaleza do Leão', 'Bastião Rubro', 'Cidadela de Prata', 'Torre dos Corvos', 'Salão do Dragão'];

export const HOUSES: HouseDef[] = (() => {
  const out: HouseDef[] = [];
  let id = 1;
  for (const size of ['small', 'medium', 'large'] as HouseSize[]) {
    const z = HOUSE_SIZES[size];
    for (let i = 0; i < z.count; i++, id++) {
      const street = STREETS[(id - 1) % STREETS.length]!;
      out.push({ id, name: `${street}, ${Math.floor((id - 1) / STREETS.length) * 2 + 1 + (size === 'small' ? 0 : size === 'medium' ? 100 : 200)}`, size, minBid: z.minBid, rent: z.rent });
    }
  }
  for (const n of GUILDHALLS) { out.push({ id: id++, name: n, size: 'guild', minBid: HOUSE_SIZES.guild.minBid, rent: HOUSE_SIZES.guild.rent }); }
  return out;
})();
export const houseById = (id: number) => HOUSES.find((h) => h.id === id);
export const houseMap = (id: number) => `house-${id}`;

/** estado de uma casa que o navegador recebe */
export interface HouseInfo {
  id: number; owner?: string; ownerId?: number; guild?: string; paidUntil?: number; open?: boolean; guests?: string[];
  bid?: number; bidder?: string; bidderId?: number; auctionEnd?: number; decor?: number;
}
